// @flow
/** @jsx jsx */

import { jsx, css } from '@emotion/core';
import * as React from 'react';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import cuid from 'cuid';

import LabelCell from './LabelCell';
import FormRow from './FormRow';
import Dropdown from './Dropdown';
import DescriptionCell from './DescriptionCell';
import { MobileView } from '../config/mediaQuery';

type Props = {
  className?: any,
  labelClassName?: any,
  disabled?: boolean,
  value: string | number,
  title: string,
  onChange?: string => mixed,
  options: Array<{
    value: any,
    text: string,
    id: string,
  }>,
  name: string,
  setFieldValue?: (field: string, val: any) => mixed,
  setFieldTouched?: (field: string, val: any) => mixed,
  errors?: {
    [name: string]: string,
  },
  touched?: {
    [name: string]: string,
  },
  showErrorMsg?: boolean,
  mobileModal: Boolean,
};

const defaultStyle = css`
  margin-bottom: 15px;
`;

class DropdownField extends React.Component<Props> {
  onChange = (value: any) => {
    if (typeof this.props.setFieldValue === 'function') {
      this.props.setFieldValue(this.props.name, value);
    }

    let valueFull = '';
    this.props.options.forEach(item => {
      if (item.value === value) {
        valueFull = item.text;
      }
    });

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value, valueFull);
    }
  };

  onToggle = (opened: boolean) => {
    if (typeof this.props.setFieldTouched === 'function' && opened === false) {
      this.props.setFieldTouched(this.props.name, true);
    }
  };

  render() {
    const { title, value, disabled, options, className, mobileModal } = this.props;
    const withError = !!(
      this.props.name &&
      // $FlowFixMe
      this.props.errors[this.props.name] &&
      // $FlowFixMe
      this.props.touched[this.props.name]
    );

    return (
      <MobileView>
        {(isMobile) => (
          <FormRow css={[defaultStyle, className, { ...(mobileModal && { alignItems: 'center' }) }]}>
            {!mobileModal || !isMobile ?
              <LabelCell
                css={[this.props.labelClassName]}
              >
                <ControlLabel>{title}</ControlLabel>
              </LabelCell>
              :
              <div className='input-label'>
                {title}
              </div>
            }
            <DescriptionCell
              css={{
                position: 'relative',
              }}
            >
              <Dropdown
                disabled={disabled}
                onChange={this.onChange}
                onToggle={this.onToggle}
                selected={value}
                options={options}
                id={cuid()}
                align="left"
                withError={withError && this.props.showErrorMsg === false}
              />
              {withError && this.props.showErrorMsg !== false && (
                <HelpBlock
                  css={{
                    position: 'absolute',
                    bottom: '-30px',
                  }}
                >
                  {
                    // $FlowFixMe
                    this.props.errors[this.props.name]
                  }
                </HelpBlock>
              )}
            </DescriptionCell>
          </FormRow>
        )}

      </MobileView>
    );
  }
}

export default DropdownField;
